package com.nonopn.skywatcher.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.home.LocalThunderDetectionModel
import com.nonopn.skywatcher.common.app.pages.administrators.UserMode
import com.nonopn.skywatcher.common.app.pages.scan.ScanQrContent
import com.nonopn.skywatcher.common.app.pages.sentinels.ThunderDetectionWithMetadata
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavBackStackEntryWrapper
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.Router
import kotlinx.serialization.Serializable

@Serializable
data class RouteUsersScanQr(
    val uuid: String,
) : RouteParameterSentinel {
    override fun uuid() = uuid
}

object RouterUsersScanQr : Router<RouteUsersScanQr>, RouterThunderDetectionSelected {
    override val klass = RouteUsersScanQr::class

    override fun route(navBackStackEntry: NavBackStackEntryWrapper) =
        RouteUsersScanQrImpl(navBackStackEntry.toRoute(RouteUsersScanQr::class))

    override fun isMatching(route: String) = null != extract(route)

    override fun navigateFrom(path: String) = RouteUsersScanQr(uuid = extract(path)!!)

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        routeParameterTo is RouteUsersScanQr

    override fun navigateTo(uuid: String) = NavigateTo(
        route = RouteUsersScanQr(uuid = uuid),
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = false,
                popUpBackTo = RouteUsers(uuid)
            )
        )
    )

    private fun extract(path: String): String? {
        val split = path.split("/")

        if (split.size < expectedSplitSize) {
            return null
        }

        if (split[indexUsers] != "users") {
            return null
        }

        if (split[indexScan] != "scan") {
            return null
        }

        if (split[indexSentinel] == "sentinel") {
            return split[indexUuid]
        }

        return null
    }

    private const val expectedSplitSize = 5
    private const val indexSentinel = 1
    private const val indexUuid = 2
    private const val indexUsers = 3
    private const val indexScan = 4
}

class RouteUsersScanQrImpl(params: RouteUsersScanQr) : Route<RouteUsersScanQr>(
    "/sentinel/{uuid}/users/scan",
    params = params,
) {
    @Composable
    override fun scene() {
        println("RouteDetection")
        val model = LocalThunderDetectionModel.current
        val selected = model.states.value.selectedThunderDetection

        if (selected.detection.uuid != params.uuid) return

        val provider = LocalAppBarProvider.current
        LaunchedEffect(provider) {
            onInternalEntryIsActive(
                provider,
                selected,
                emptyList()
            )
        }

        ScanQrContent(Modifier.fillMaxSize(), selected, UserMode.User)
    }

    private fun onInternalEntryIsActive(
        model: AppBarStateProvider,
        thunderDetection: ThunderDetectionWithMetadata,
        defaultActions: List<MenuItem>
    ): String {

        model.setAppBarState(
            AppBarState.Regular(
                title = "Scan",
                defaultActions
            )
        )

        return "/sentinel/${thunderDetection.detection.uuid}/users/scan"
    }
}
